import React from 'react';

const Holidays = () => {
    return (
        <div>
            חגים ומועדים

            ????
            טבלה
        </div>
    );
};

export default Holidays;